const items = {
  "forms.fields.email.label": "电子邮箱",
  "forms.fields.email.or.username.label": "电子邮箱/用户名",
  "forms.fields.password.label": "密码",
  "forms.fields.confirm-password.label": "确认密码",
  "forms.fields.id.label": "ID",
  "forms.fields.message.label": "消息",
  "forms.fields.created-at.label": "创建时间",
  "forms.fields.updated-at.label": "更新时间",
  "forms.fields.lang.label": "语言",
  "forms.message.lang.required": "请选择一种语言",
  "forms.fields.title.label": "标题",
  "forms.message.title.required": "请输入标题",
  "forms.fields.subtitle.label": "副标题",
  "forms.fields.summary.label": "摘要",
  "forms.fields.content.label": "内容",
  "forms.fields.content.placeholder": "请输入内容",
  "forms.fields.tag.label": "标签",
  "forms.fields.power.label": "权限",
  "forms.fields.type.label": "类型",
  "forms.fields.publicity.label": "公开性",
  "forms.fields.publicity.all.label": "全部",
  "forms.fields.publicity.disable.label": "禁用",
  "forms.fields.publicity.blocked.label": "锁定",
  "forms.fields.publicity.private.label": "私有",
  "forms.fields.publicity.public_no_list.label": "公开不列出",
  "forms.fields.publicity.public.label": "公开",
  "forms.fields.publicity.public.edit.label": "公开可编辑",
  "forms.fields.teacher.label": "主讲人",
  "forms.fields.studentsassistant.label": "学生与助教",
  "forms.fields.student.label": "学生",
  "forms.fields.assistant.label": "助教",
  "forms.fields.lesson.label": "讲",
  "forms.fields.note.label": "注解",
  "forms.fields.confidence.label": "信心指数",
  "forms.fields.confidence.0.label": "不靠谱",
  "forms.fields.confidence.25.label": "没把握",
  "forms.fields.confidence.50.label": "一般",
  "forms.fields.confidence.75.label": "还可以",
  "forms.fields.confidence.100.label": "有把握",
  "forms.fields.upload.texture": "上传封面",
  "forms.fields.markdown.label": "markdown效果预览",
  "forms.fields.role.label": "角色",
  "forms.fields.name.label": "名称",
  "forms.fields.meaning.label": "整体含义",
  "forms.fields.meaning.tooltip": "最长为 256个字符",
  "forms.message.meaning.required": "请输入意思",
  "forms.fields.factors.label": "拆分方式",
  "forms.fields.factors.tooltip": "最长为 256个字符",
  "forms.fields.factor.meaning.label": "拆分含义",
  "forms.fields.factor.meaning.tooltip": "最长为 256个字符",
  "forms.fields.parent.label": "词典源型",
  "forms.fields.parent.tooltip": "最长为 256个字符",
  "forms.fields.case.label": "语法信息",
  "forms.fields.case.tooltip": "语法信息参见……",
  "forms.fields.user.label": "用户",
  "forms.message.user.required": "请选择用户",
  "forms.message.user.delete": "删除用户吗？此操作无法恢复。",
  "forms.message.member.remove": "移除此成员吗？此操作无法恢复。",
  "forms.fields.description.label": "简介",
  "forms.fields.textbook.label": "课本",
  "forms.fields.status.label": "状态",
  "forms.fields.ending.label": "语尾",
  "forms.fields.relation.label": "关系",
  "forms.fields.from.label": "从",
  "forms.fields.to.label": "连接到",
  "forms.fields.count.label": "计数",
  "forms.fields.owner.label": "拥有者",
  "forms.message.res.remove": "将此资源从群中移除吗？",
  "forms.fields.parent2.label": "衍生原型",
  "forms.fields.parent2.tooltip": "最长为 256个字符",
  "forms.fields.username.label": "用户名(登录名)",
  "forms.fields.nickname.label": "昵称",
  "forms.fields.editor.label": "编辑者",
  "forms.fields.category.label": "分类",
  "forms.fields.match.label": "匹配方式",
  "forms.fields.dict.name.label": "字典名",
  "forms.fields.dict.shortname.label": "字典名",
  "forms.fields.url.label": "url",
  "forms.fields.fail.label": "失败",
  "forms.fields.success.label": "成功",
  "forms.fields.receiver.label": "接收",
  "forms.fields.event.label": "事件",
  "forms.message.question.required": "请输入您的问题（必填）",
  "forms.message.question.description.option": "问题详细描述（选填）",
  "forms.fields.replay.label": "回复",
  "forms.status.transferred.label": "等待处理",
  "forms.status.accept.label": "已经接受",
  "forms.status.refuse.label": "已经拒绝",
  "forms.status.cancel.label": "已经撤回",
  "forms.fields.sign-up-message.label": "报名消息",
  "forms.fields.color.label": "颜色",
  "forms.fields.executors.label": "执行者们",
  "forms.fields.executor.label": "执行者",
  "forms.fields.milestone.label": "里程碑",
  "forms.fields.started-at.label": "开始时间",
  "forms.fields.finished-at.label": "完成时间",
  "forms.fields.assignees.label": "指派给",
  "forms.fields.model.label": "模型",
  "forms.fields.key.label": "密钥",
};

export default items;
